module.exports = Object.keys || require('./shim');




//////////////////
// WEBPACK FOOTER
// ./~/object-keys/index.js
// module id = 250
// module chunks = 0